import { render, staticRenderFns } from "./AllergensDictionary.vue?vue&type=template&id=b5b05c66&lang=pug&"
import script from "./AllergensDictionary.vue?vue&type=script&lang=js&"
export * from "./AllergensDictionary.vue?vue&type=script&lang=js&"
import style0 from "./AllergensDictionary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports